const Order = () => {
    return (<></>)
}

export default Order;